define('fukit/behavior/change.visibility.on.model.create.behavior',['require','marionette','backbone.radio'],function(require) {
  //prettier-ignore
  var Mn    = require('marionette'),
      Radio = require('backbone.radio');

  var ChangeVisibilityOnModelCreateBehavior = Mn.Behavior.extend({
    defaults: {
      visibleWhenNew: false,
    },

    modelEvents: {
      sync: 'updateViewVisibility',
    },

    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);

      this.once('before:render', function() {
        this.updateViewVisibility();
      });
    },

    updateViewVisibility: function() {
      if (this.view.model && this.view.canOverride !== false) {
        this.view.visible = this.shouldViewBeVisible();
      }
    },

    shouldViewBeVisible: function() {
      var isModelNew = this.view.model.isNew();
      return this.getOption('visibleWhenNew') ? isModelNew : !isModelNew;
    },
  });

  return ChangeVisibilityOnModelCreateBehavior;
});

